import { twoToThreeCountryCode } from '@intigral/constant';

/**
 * Retrieves the three-letter country code based on the two-letter country code.
 * @param {string} twoLetterCountryCode - The two-letter country code.
 * @returns {string} - The three-letter country code corresponding to the provided code, defaults to 'KSA' if no match is found.
 */
export const getThreeLetterCountryCode = (twoLetterCountryCode: string): string => {
    // Retrieve the three-letter country code from the map based on the provided two-letter code
    const countryCode = twoToThreeCountryCode[twoLetterCountryCode.toLowerCase()];
    return countryCode || 'KSA';
};

/**
 * Retrieve the two-letter country code from the map based on the provided three-letter code
 * @param {string} threeLetterCountryCode
 * @returns {string} Two letter country
 */
export const getTwoLetterCountryCode = (threeLetterCountryCode: string): string => {
    const countryCode = Object.keys(twoToThreeCountryCode).find(
        (key) => twoToThreeCountryCode[key].toLowerCase() === threeLetterCountryCode.toLowerCase()
    );
    return countryCode || 'sa';
};
